import Vue from 'vue';
import store from "../store/index";
import router from "../router"; // 路由配置
import axios from "axios";// 创建axios实例

const service = axios.create({
    baseURL: (store.state as any).baseURL, // api的base_url
    timeout: 50000 // 请求超时时间
});

// request拦截器 axios的一些配置
service.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        let token = (store.state as any).token;

        if (token) {
            config.headers.Authorization = "Bearer " + token;
        }
        return config;
    },
    error => {
        // Do something with request error
        console.error("error:", error); // for debug
        Promise.reject(error);
    }
);

// respone拦截器 axios的一些配置
service.interceptors.response.use(
    response => {
        console.log(response)
        if (response.status >= 200 && response.status<400) {
            return response.data;
        } else {
            Vue.prototype.$message({
                type: "error",
                message: response.data.msg
            });
        }
    },
    error => {
        if (error.response) {

            switch (error.response.status) {
                case 400:
                    if (error.response.data.errors) {
                        // WebAPI 模型验证错误
                        for (let e in error.response.data.errors) {
                            //console.log(error.response.data.errors[e])
                            for (let i = 0; i < error.response.data.errors[e].length; ++i) {
                                Vue.prototype.$message({
                                    type: "error",
                                    message: error.response.data.errors[e][i]
                                });
                            }
                        }
                    } else {
                        // 自定义400错误
                        Vue.prototype.$message({
                            type: "error",
                            message: error.response.data
                        });
                    }
                    break;
                case 401:
                    Vue.prototype.$message({
                        type: "error",
                        message: "身份验证失效或已过期，请重新登录"
                    });
                    setTimeout(() => { router.push({ path: "/login" }) }, 1000);
                    break;
                case 404:
                    Vue.prototype.$message({
                        type: "error",
                        message: error.response.data
                    });
                    break;
                case 500:
                    Vue.prototype.$message({
                        type: "error",
                        message: "服务器错误"
                    });
                    break;
                default:
                    console.error("error:" + error); // for debug
                    if (error.response.data.msg) {
                        Vue.prototype.$message({
                            type: "error",
                            message: error
                        });
                    } else {
                        Vue.prototype.$message({
                            type: "error",
                            message: error
                        });
                    }
                    break;
            }
            return Promise.reject(error);
        }
    }
);

export default service;